Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
exports.notificationsMiddleware = function (store) { return function (next) { return function (action) {
    var result = next(action);
    if (action.meta !== undefined && action.meta.notification !== undefined) {
        store.dispatch(actions_1.triggerNotification(action.meta.notification));
    }
    return result;
}; }; };
